/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-06 16:14:05
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-22 10:47:32
 */
import api from '@/api'
import tim from '../../tim'
import {scrollChatListDown} from '../../utils/index'
import {updateCurrSessionMsgs} from '../mutations'
const state = {
    userId:'',
    userSig:'',
    friendId:'',
    consultId:'',
    chatType:'C2C',
    nextReqMessageID:'',
    messageList:[],
    oldMessage:{},
    SDKReady:false,
    startChat:[],
    stopChat:[],
    startChatTime:{}
}
const mutations = {
    changeUserId:(state, userId) => {
        state.userId = userId
    },
    changeUserSig:(state, userSig) => {
        state.userSig = userSig
    },
    changeNextReqMessageID:(state, nextReqMessageID) => {
        state.nextReqMessageID = nextReqMessageID
    },
    changeMessageList:(state, messageList) => {
        state.messageList = messageList
    },
    changeFriendId:(state, friendId) => {
        state.friendId = friendId
    },
    changeConsultId:(state, consultId) => {
        state.consultId = consultId
    },
    changeOldMeaasge:(state, message) => {
        state.oldMessage = message
    },
    toggleIsSDKReady:(state, SDKReady) => {
        state.SDKReady = SDKReady
    },
    updateCurrSessionMsgs,
}
const actions = {
    imLogin({commit,state,dispatch},data){
        console.log('开始登录',data)
        let userID = JSON.parse(JSON.stringify(state.userId))
        let userSig = JSON.parse(JSON.stringify(state.userSig)) 
        if(data){
            commit('changeUserId',data.userID)
            commit('changeUserSig',data.userSig)
            if(data.friendId){
                commit('changeFriendId',data.friendId)  
            }
            if(data.consultId){
                let message = state.oldMessage[data.consultId]||{}
                commit('changeMessageList',message.message||[])
                commit('changeConsultId',data.consultId)
            }
             //判断当前有没有登录的用户 如果有先退出当前用户再登录
            if(userID&&userID!==data.userID){
                dispatch('clearStatus')
                dispatch('imLogout',data)
                return
            }
        }
        console.log('登录开始',state.userId)
        return new Promise((res,rej)=>{
            tim.login({
                userID:state.userId,
                userSig:state.userSig
            }).then((imResponse) => {
                if (imResponse.data.repeatLogin === true) {
                    // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
                    let newMesObj = state.oldMessage[state.consultId]
                    if(!(newMesObj&&newMesObj.message.length > 0)){
                        dispatch('getMessages')
                    }
                }
                res()
            }).catch(err=>{
                console.log(err)
            })
        })
        
    },
    imLogout({commit,state,dispatch},{data,needLogin}){
        let promise = tim.logout();
        promise.then(function(imResponse) {
            console.log('退出成功')
            dispatch('imLogin')
        }).catch(function(imError) {
            console.warn('logout error:', imError);
        });
    },
    /**
     * 登录状态
     */
    changeSDKReady({commit,state,dispatch},data){
        commit('toggleIsSDKReady',data)
        if(data&&state.consultId){
            dispatch('getMessages')
        }
    },
    /**
     * 切换账号后初始化数据
     */
    clearStatus({commit,state}){
        // commit('changeNextReqMessageID','')
        commit('toggleIsSDKReady',false)
        commit('changeOldMeaasge',{})
    },
    getMessages({commit,state}){
        let conversationID = `${state.chatType}${state.friendId}`
        let oldMessage = state.oldMessage[state.consultId]
        let nextReqMessageID = oldMessage&&oldMessage.nextReqMessageID
        // console.log(conversationID,nextReqMessageID)
        return new Promise((res,rej)=>{
            tim.getMessageList({conversationID,nextReqMessageID,count:30}).then(({data})=>{
                let message = data.messageList
                // console.log('message',message)
                commit('changeNextReqMessageID',data.nextReqMessageID)
                //初始化或者拉取历史消息
                commit('updateCurrSessionMsgs',{
                    type:nextReqMessageID?'concat':'init',
                    message,
                    nextReqMessageID:data.nextReqMessageID
                })
                res()
            })
        })
        
    },
    /**
     * 发送消息
     */
    sendMessage({commit,state,dispatch}, {to,type,teamId='-1',consultId,payload,consultStatus,time}){
        let func = tim.createTextMessage
        let cloudCustomData = {
            imtype:'consult',
            id:consultId,
            teamId:teamId,
            consultStatus,
        }
        if(type === 'image'){
            func = tim.createImageMessage
        }
        if(type === 'audio'){
            cloudCustomData['imtype'] = 'audio'
            cloudCustomData['audioTime'] = time
            func = tim.createFileMessage
        }
        let message = func({
            conversationType: TIM.TYPES.CONV_C2C,
            cloudCustomData:JSON.stringify(cloudCustomData),
            to,
            payload
        });
        //本地未发送消息
        commit('updateCurrSessionMsgs',{
            type:'put',
            message
        })
        scrollChatListDown()
        if(type === 'text'){
          return  dispatch('sendText',message)
        }
        if(type === 'image'){
            return  dispatch('sendImage',message)
        }
        if(type === 'audio'){
            return  dispatch('sendAudio',message)
        }
    },
    /**
     * 文本类型
     */
    sendText({commit,state},message){
        
        
        let promise = tim.sendMessage(message);
        return new Promise((res,rej)=>{
            promise.then(function(imResponse) {
                // 发送成功
                commit('updateCurrSessionMsgs',{
                    type:'replace',
                    message:imResponse.data.message
                })
                res(imResponse);
              }).catch(function(imError) {
                // 发送失败
                console.warn('sendMessage error:', imError);
                rej(imError)
              });
        })
          
    },
    /**
     * 图片消息
     */
    sendImage({commit,state},message){
          // 2. 发送消息
          let promise = tim.sendMessage(message);
          return new Promise((res,rej)=>{
            promise.then(function(imResponse) {
                // 发送成功
                commit('updateCurrSessionMsgs',{
                    type:'replace',
                    message:imResponse.data.message
                })
                res(imResponse);
              }).catch(function(imError) {
                // 发送失败
                console.warn('sendMessage error:', imError);
                rej(imError)
              });
          })
          
    },
    /**
     * 语音消息：通过文件类型发
     */
    sendAudio({commit,state},message){
        let promise = tim.sendMessage(message);
    }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/im.js